export enum QuestionTypes {
  Single = 'Single',
}

export enum SectionTypes {
  Positive = 'Positive',
  Negative = 'Negative',
}
